import { IRowNode } from "ag-grid-community";
import { AgGridReact, RadioButton } from "@jsq/ds/core";
import { HeaderComponent } from "./HeaderComponent";
import { cellContentStyle } from "./styles_vanilla.css";

export type SelectedSource = "current" | "extracted" | null;

export type ConflictRowData = {
  fieldName: string;
  currentValue: string;
  extractedValue: string;
  selectedSource: SelectedSource;
};

type CellRendererParams = {
  data: ConflictRowData;
  node: IRowNode<ConflictRowData>;
};

export const gridOptions: AgGridReact.AgGridReactProps["gridOptions"] = {
  rowHeight: 42,
  suppressCellFocus: true,
  suppressRowHoverHighlight: true,
  domLayout: "autoHeight",
  autoSizeStrategy: {
    type: "fitGridWidth",
  },
};

export const createColDefs = ({
  profileName,
  documentName,
}: {
  profileName: string;
  documentName: string;
}): AgGridReact.AgGridReactProps["columnDefs"] => [
  {
    field: "fieldName",
    headerName: "",
    sortable: false,
    width: 180,
  },
  {
    field: "currentValue",
    headerComponent: HeaderComponent,
    headerComponentParams: {
      colHeaderTitle: "Current profile data",
      secondaryTitle: profileName,
    },
    autoHeaderHeight: true,
    minWidth: 200,
    cellRenderer: RadioButton,
    cellRendererParams: (params: CellRendererParams) => ({
      name: params.data?.fieldName,
      children: params.data?.currentValue,
      value: "current",
      checked: params.data?.selectedSource === "current",
      onChange: () => {
        params.data.selectedSource = "current";
        params.node.setData(params.data);
      },
    }),
    cellClass: () => {
      return cellContentStyle;
    },
  },
  {
    field: "extractedValue",
    headerComponent: HeaderComponent,
    headerComponentParams: {
      colHeaderTitle: "Extracted data from document",
      secondaryTitle: documentName,
    },
    autoHeaderHeight: true,
    minWidth: 200,
    cellRenderer: RadioButton,
    cellRendererParams: (params: CellRendererParams) => ({
      name: params.data?.fieldName,
      children: params.data?.extractedValue,
      value: "extracted",
      checked: params.data?.selectedSource === "extracted",
      onChange: () => {
        params.data.selectedSource = "extracted";
        params.node.setData(params.data);
      },
    }),
    cellClass: () => {
      return cellContentStyle;
    },
  },
];
